'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATA_BY_CATEGORY = exports.getEmojiFromUnicode = exports.SHORTCODE_TO_EMOJI = exports.EMOTICON_TO_EMOJI = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

exports.replaceEmoticons = replaceEmoticons;

var _compact = require('emojibase-data/en/compact.json');

var _compact2 = _interopRequireDefault(_compact);

var _emojibase = require('emojibase-data/en/shortcodes/emojibase.json');

var _emojibase2 = _interopRequireDefault(_emojibase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 The Matrix.org Foundation C.I.C.
Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var EMOTICONTREE = {};

// The unicode is stored without the variant selector
var UNICODE_TO_EMOJI = new _map2.default(); // not exported as gets for it are handled by getEmojiFromUnicode
var EMOTICON_TO_EMOJI = exports.EMOTICON_TO_EMOJI = new _map2.default();
var SHORTCODE_TO_EMOJI = exports.SHORTCODE_TO_EMOJI = new _map2.default();

var getEmojiFromUnicode = exports.getEmojiFromUnicode = function getEmojiFromUnicode(unicode) {
  return UNICODE_TO_EMOJI.get(stripVariation(unicode));
};

/**
 * Greedily replace emoticons with emoji symbols, using `EMOTICONTREE` to aid lookup.
 */
function replaceEmoticons(text) {
  var boundary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\s/;
  var padSpaceAfter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var active = true;
  var matches = [];
  text = (0, _from2.default)(text);
  var pad = padSpaceAfter ? ' ' : '';

  for (var i = 0; i < text.length; i++) {
    var c = text[i];
    // console.debug(`prefix=${text.slice(0,i)}, c=${c}, active=${active}`);
    if (c.match(boundary)) {
      active = true;
      continue;
    }
    if (active) {
      var level = EMOTICONTREE;
      var currentMatch = void 0;
      var s = i;

      while (level[c] && i < text.length) {
        level = level[c];
        if (level.M) {
          currentMatch = level.M;
        }
        i++;
        c = text[i];
      }
      if (currentMatch) {
        matches.push([s, i, currentMatch]);
        active = true;
        i--;
        continue;
      }
    }
    active = false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(matches.reverse()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var m = _step.value;

      text.splice(m[0], m[1] - m[0], m[2] + pad);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return text.join('');
}

/**
 * Strips variation selectors from the end of given string
 * NB. Skin tone modifiers are not variation selectors:
 * this function does not touch them. (Should it?)
 *
 * @param {string} str string to strip
 * @returns {string} stripped string
 */
function stripVariation(str) {
  return str.replace(/[\uFE00-\uFE0F]$/, "");
}

var EMOJIBASE_GROUP_ID_TO_CATEGORY = ['people', // smileys
'people', // actually people
'control', // modifiers and such, not displayed in picker
'nature', 'foods', 'places', 'activity', 'objects', 'symbols', 'flags'];

var DATA_BY_CATEGORY = exports.DATA_BY_CATEGORY = {
  people: [],
  nature: [],
  foods: [],
  places: [],
  activity: [],
  objects: [],
  symbols: [],
  flags: []
};

function mergeTree(s, t, u) {
  t = (0, _from2.default)(t);
  var _ref = [t[0], t.slice(1)],
      c = _ref[0],
      r = _ref[1];

  s[c] = s[c] || {};
  if (!r.length) {
    s[c] = (0, _extends3.default)({}, s[c], { M: u });
  } else {
    s[c] = mergeTree(s[c], r, u);
  }
  return s;
}

_compact2.default.forEach(function (emoji) {
  var categoryId = EMOJIBASE_GROUP_ID_TO_CATEGORY[emoji.group];
  if (DATA_BY_CATEGORY.hasOwnProperty(categoryId)) {
    DATA_BY_CATEGORY[categoryId].push(emoji);
  }
  var shortCodeLookup = _emojibase2.default[emoji.hexcode] || '';
  var shortcodes = (shortCodeLookup && !Array.isArray(shortCodeLookup) ? [shortCodeLookup] : shortCodeLookup) || [];
  var emoticon = (emoji.emoticon && !Array.isArray(emoji.emoticon) ? [emoji.emoticon] : emoji.emoticon) || [];
  // This is used as the string to match the query against when filtering emojis
  emoji.filterString = (emoji.label + '\n' + shortcodes.join('\n') + '}\n' + emoticon.join('\n')).toLowerCase();

  // Add mapping from unicode to Emoji object
  UNICODE_TO_EMOJI.set(stripVariation(emoji.unicode), emoji);

  if (emoticon) {
    // Add mapping from emoticon to Emoji object
    emoticon.forEach(function (emoticon) {
      EMOTICON_TO_EMOJI.set(emoticon, emoji);
    });
  }

  if (shortcodes) {
    // Add mapping from each shortcode to Emoji object
    shortcodes.forEach(function (shortcode) {
      SHORTCODE_TO_EMOJI.set(shortcode, emoji);
    });
  }
});

(0, _from2.default)(EMOTICON_TO_EMOJI).map(function (_ref2) {
  var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
      emoticon = _ref3[0],
      emojiObj = _ref3[1];

  return [emoticon, emojiObj.unicode];
}).sort(function (a, b) {
  return a[0].length > b[0].length ? 1 : a[0].length === b[0].length ? 0 : -1;
}).reverse().forEach(function (_ref4) {
  var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
      emoticon = _ref5[0],
      emoji = _ref5[1];

  return mergeTree(EMOTICONTREE, emoticon, emoji);
});
//# sourceMappingURL=emoji.js.map